import type { AnnouncementType } from '../../../types/api/announcements.types';

/**
 * The heading a client sees above an announcement, per type.
 *
 * Also the list of types this build knows how to draw: the backend adds new
 * `type`s without changing the response shape, so anything not in this map is
 * skipped entirely rather than rendered as a bare card with no context.
 */
export const ANNOUNCEMENT_TYPE_LABEL: Record<AnnouncementType, string> = {
  whatsNew: "What's New",
};

export const isKnownAnnouncementType = (
  type: string
): type is AnnouncementType => type in ANNOUNCEMENT_TYPE_LABEL;
